/**
 * Created by chachora on 11/20/18.
 */
import React, { FC, useEffect, useRef, useState } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useNavigationType,
} from 'react-router-dom';
import AuthHelper from './helpers/auth-helper';
import { MainPage } from './pages/MainPage';
import { LoginPage } from './pages/LoginPage';
import polling from './store/polling';
import ReportsDialog from './components/ReportsDialog/ReportsDialog';
import StatsDialog from './components/StatsDialog/StatsDialog';
import UsersDialog from './components/UsersDialog/UsersDialog';
import { EventDialog } from './components/EventDialog/EventDialog';
import { useEventCallback } from './helpers/hooks';
import { UsersList } from './components/UsersDialog/UsersList';
import UserEditor from './components/UsersDialog/UserEditor';
import useNetworkStatus from './helpers/useNetworkStatus';

const AppRoutes: FC = () => {
  useNetworkStatus();
  const [isLoggedIn, setLoggedIn] = useState<boolean>(!!AuthHelper.getToken());
  const stopPollingRef = useRef<(() => void) | null>(null);
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const handleGoBack = useEventCallback(() => {
    if (navigationType === 'PUSH') navigate(-1);
    else navigate('/');
  });

  useEffect(() => {
    // Token
    const checkToken = setInterval(() => {
      const token = AuthHelper.getToken();
      if (isLoggedIn !== !!token) setLoggedIn(!!token);
    }, 500);

    // Polling
    stopPollingRef.current?.();
    stopPollingRef.current = null;
    if (isLoggedIn) stopPollingRef.current = polling();

    return () => {
      clearInterval(checkToken);
      stopPollingRef.current?.();
      stopPollingRef.current = null;
    };
  }, [isLoggedIn]);

  return (
    <>
      <Routes>
        <Route
          path="/login"
          element={
            <>
              {isLoggedIn && <Navigate to="/" replace={true} />}
              <LoginPage />
            </>
          }
        />
        <Route path="/" element={<MainPage />}>
          <Route
            path="events/:eventId"
            element={<EventDialog onClose={handleGoBack} />}
          />
          <Route
            path="reports"
            element={<ReportsDialog isOpen={true} onClose={handleGoBack} />}
          />
          <Route
            path="statistics"
            element={<StatsDialog isOpen={true} onClose={handleGoBack} />}
          >
            <Route
              path="events/:eventId"
              element={<EventDialog onClose={handleGoBack} />}
            />
          </Route>
          <Route
            path="users"
            element={<UsersDialog isOpen={true} onClose={handleGoBack} />}
          >
            <Route path="" element={<UsersList />} />
            <Route path="add" element={<UserEditor />} />
            <Route path="edit/:id" element={<UserEditor />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace={true} />} />
      </Routes>
      {!isLoggedIn && <Navigate to={'/login'} replace={true} />}
    </>
  );
};

export default AppRoutes;
